import { useSelector } from 'react-redux';
import { currencyToSymbol } from 'utils/currencies';
import { makeStyles } from '@material-ui/styles';
import { type Brands } from 'types/Brands';
import { navyColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  headerWrapper: {
    marginBottom: '6px',
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: '400',
    color: navyColor,
  },
});

type HeaderProps = {
  title: string;
  isValidator: boolean;
  value: number;
  negativeValue?: boolean;
};
const Header = ({ title, isValidator, value, negativeValue }: HeaderProps) => {
  const classes = useStyles();

  const currency = useSelector(
    ({ Brands }: { Brands: Brands }) => Brands.brand.multinational.currency
  );

  return (
    <div className={classes.headerWrapper}>
      <span>{title}:</span>
      <span>
        {isValidator
          ? `${negativeValue ? '-' : ''}${(value || 0).toFixed(
              2
            )} ${currencyToSymbol(currency)}`
          : '-'}
      </span>
    </div>
  );
};

export default Header;
